// BeeNexa Hive — category catalog.
// `id` matches an app's `category` field and the accent gradient key in
// theme/tokens.js (CATEGORY_GRADIENTS). Icons are lucide-react names.

export const CATEGORIES = [
  { id: 'business', label: 'Business', icon: 'Store', order: 1 },
  { id: 'restaurant', label: 'Restaurant', icon: 'Utensils', order: 2 },
  { id: 'booking', label: 'Booking', icon: 'CalendarCheck', order: 3 },
  { id: 'realEstate', label: 'Real Estate', icon: 'Home', order: 4 },
  { id: 'gameRooms', label: 'Game Rooms', icon: 'Gamepad2', order: 5 },
  { id: 'finance', label: 'Finance', icon: 'Wallet', order: 6 },
  { id: 'event', label: 'Event Planning', icon: 'PartyPopper', order: 7 },
  { id: 'personal', label: 'Personal', icon: 'User', order: 8 },
];

export const CATEGORY_BY_ID = CATEGORIES.reduce((acc, c) => {
  acc[c.id] = c;
  return acc;
}, {});

export const categoryLabel = (id) => CATEGORY_BY_ID[id]?.label || id;
